import { motion } from 'framer-motion';
import { SITE } from '@/config/site';
import { scrollToTarget } from '@/hooks/useLenis';

const EASE = [0.19, 1, 0.22, 1];

function MaskedLine({ children, delay, instant }) {
  return (
    <span className="line-mask">
      <motion.span className="block" initial={instant ? false : { y: '112%' }} animate={{ y: 0 }} transition={{ duration: 1.15, delay, ease: EASE }}>
        {children}
      </motion.span>
    </span>
  );
}

export default function HeroCopy({ instant = false }) {
  const fade = (d) =>
    instant
      ? {}
      : { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: EASE } };
  return (
    <div className="relative z-10 flex h-full flex-col justify-end px-5 pb-28 sm:px-10 sm:pb-14">
      <motion.p {...fade(0.15)} className="mb-5 flex items-center gap-3 text-[10px] font-medium uppercase tracking-[0.45em] text-silver" data-testid="hero-eyebrow">
        <span className="inline-block h-1 w-1 rounded-full bg-gold" /> Cristian Cruz
      </motion.p>
      <h1 className="font-display text-[10vw] uppercase leading-[0.98] text-cream sm:text-6xl lg:text-7xl" data-testid="hero-headline">
        <MaskedLine delay={0.28} instant={instant}>
          Llegue a USA
        </MaskedLine>
        <MaskedLine delay={0.38} instant={instant}>
          como migrante
        </MaskedLine>
        <MaskedLine delay={0.48} instant={instant}>
          y la reventa me
        </MaskedLine>
        <MaskedLine delay={0.58} instant={instant}>
          cambio la vida<span className="text-gold">.</span>
        </MaskedLine>
      </h1>
      <motion.p {...fade(0.7)} className="mt-6 text-[9px] uppercase tracking-[0.24em] text-cream/60 sm:text-xs sm:tracking-[0.3em]" data-testid="hero-tagline">
        Productos <span className="mx-1 text-gold">·</span> Estrategia <span className="mx-1 text-gold">·</span> Ventas <span className="mx-1 text-gold">·</span> Escala
      </motion.p>
      <motion.div {...fade(0.85)} className="pointer-events-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row sm:gap-4">
        <a
          data-testid="hero-cta-whatsapp"
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-full bg-cream px-8 py-4 text-[11px] font-medium uppercase tracking-[0.25em] text-noir transition-colors duration-300 hover:bg-gold"
        >
          Quiero empezar
        </a>
        <button
          data-testid="hero-cta-historia"
          type="button"
          onClick={() => scrollToTarget('#historia')}
          className="inline-flex items-center justify-center rounded-full border border-cream/25 px-8 py-4 text-[11px] uppercase tracking-[0.25em] text-cream/90 transition-colors duration-300 hover:border-gold hover:text-gold"
        >
          Conoce mi historia
        </button>
      </motion.div>
    </div>
  );
}
